// eslint-disable-next-line aloft/no-sui-chakra
import { MenuListProps, MenuProps } from '@aloft/toolkit-sui/chakra';

import { borderColor, borderStyle } from '../../styles/border.ts';

export const menuProps: MenuProps = {
  orientation: 'vertical',
  placement: 'bottom-end',
  autoSelect: false,
  offset: [4, 4],
  children: undefined,
};

export const menuListProps: MenuListProps = {
  paddingTop: 0,
  paddingBottom: 0,
  shadow: '2xl',
  zIndex: 9999, // TODO: Don't crank z-index; I didn't feel like fiddling with stacking contexts and it's a problem if the menus aren't visible
  borderColor,
  borderStyle,
  borderWidth: '1px',
  borderRadius: '0px',
};

export const SUBNAV_HEIGHT = '2.25rem';
